module.exports = __webpack_public_path__ + "img/ch19.617414f0.png";